<template>
  <section class="lg:container lg:mx-auto px-5">
    <div class="pb-6 bg-white xl:rounded-b-lg rounded-lg border border-color-iron">
      <!-- Cover photo -->
      <div v-if="professional.cover_image == null" 
        style="background-image: url('/img/default-cover-photo.png')" 
        class="w-full h-52 profissional-photo">
      </div>
      <div v-else :style="{
        backgroundImage: `url(${professional.cover_image})`,
      }" class="w-full h-52 profissional-photo">
      </div>

      <!-- Profile photo -->
      <div :style="{ backgroundImage: `url(${professional.profile_image})` }"
        class="w-36 h-36 ml-6 md:ml-20 -mt-16 rounded-full bg-oxford-blue border-2 border-white profissional-photo">
      </div>

      <Skeleton v-if="isLoading && JSON.stringify(professional) == '{}'" height="1.5rem" class="mt-3"></Skeleton>
      <div v-else-if="!isLoading && Object.keys(professional).length > 0" class="w-full px-6 flex flex-col justify-center md:justify-normal md:pl-20 pt-3">
        <span class="flex items-center mb-2">
          <h1 class="text-2xl font-semibold capitalize text-oxford-blue">
            {{ professional.name_complete }} 
          </h1>
          <i class="pi pi-verified hidden ml-2 font-medium text-sea-serpent" style="font-size: 1.3rem;display:none"></i>
        </span>

        <h3 class="text-lg font-normal text-gray-700">
          {{ professional.title }}  
        </h3>
        <span v-if="professional.country != ''" class="flex items-center pt-3">
          <i class="pi pi-building mr-1" style="font-size: 1.2em"></i>
          <h4 class="capitalize font-semibold">Brazil, São Paulo</h4> 
          <!-- <h4 class="capitalize font-semibold">{{ professional.country || 'Brazil'}}{{', ' +professional.city}}</h4>  -->
        </span>
      </div>
    </div>

  </section>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Skeleton from 'primevue/skeleton';


const props = defineProps({
  professionalData: {
    type: Object,
    required: true,
    default: () => {}
  }
});

let isLoading = ref(true)
let professional = ref({})


onMounted(() => {
  isLoading.value = true
});

onUpdated(() => {
  if (Object.keys(props.professionalData).length > 0) {
    professional.value = props.professionalData 
  }
  isLoading.value = false
})
</script>

<style scoped>
.profissional-photo {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>